import { render, staticRenderFns } from "./isvhuahui.vue?vue&type=template&id=6543078d"
import script from "./isvhuahui.vue?vue&type=script&lang=js"
export * from "./isvhuahui.vue?vue&type=script&lang=js"
import style0 from "./isvhuahui.vue?vue&type=style&index=0&id=6543078d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports